function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(void 0);
        });
    };
}
const canvasPreview = (image, canvas, crop)=>_async_to_generator(function*() {
        const ctx = canvas.getContext('2d');
        if (!ctx) throw new Error('No 2d context');
        const canvasWidth = Math.floor(crop.width);
        const canvasHeight = Math.floor(crop.height);
        canvas.width = canvasWidth;
        canvas.height = canvasHeight;
        ctx.imageSmoothingQuality = 'high';
        ctx.drawImage(image, crop.x, crop.y, crop.width, crop.height, 0, 0, canvasWidth, canvasHeight);
    })();
export { canvasPreview };
